// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__20zr4","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1un4d"};